import { useStore } from '@xyflow/react';
import { useMemo } from 'react';

import { SELECTABLE_NODE_TYPES } from '../constants';
import { useEditCanvasStore } from '../store';
import { type AppNode } from '../types';

/**
 * Returns selected nodes from the canvas
 */
export function useSelectedCanvasNodes(): AppNode[] {
  const xyFlowNodes = useStore((state) => state.nodes);
  const canvasNodes = useEditCanvasStore((state) => state.nodes);

  return useMemo(() => {
    const selectedNodeIds = new Set(xyFlowNodes.filter((n) => n.selected).map((n) => n.id));

    return canvasNodes.filter((o) => selectedNodeIds.has(o.id) && SELECTABLE_NODE_TYPES.has(o.type));
  }, [xyFlowNodes, canvasNodes]);
}
